/* eslint-disable @typescript-eslint/ban-ts-comment */
import { dayjs } from '@2wunder/klarx-tool'
import { allLocales } from 'app/constants/Enums'
import moment from 'moment'
//@ts-ignore
import moment_de from 'moment/locale/de'
//@ts-ignore
import moment_en from 'moment/locale/en-gb'

import BrowserService from './BrowserService'
import EnvironmentService from './EnvironmentService'

class IntlService {
  static isLanguageValid(langCode: string) {
    return allLocales.filter((locale) => locale.language === langCode).length > 0
  }

  static getLocaleWithHost(locale: string) {
    return `${locale}_${
      EnvironmentService.isDevelopment() ? 'DE' : BrowserService.getDomainName().toUpperCase()
    }`
  }

  static setLocale(langCode: string = 'de') {
    moment.locale(langCode)
    dayjs.locale(langCode)
  }

  static loadLanguage = () => {
    moment.updateLocale('de', {
      ...moment_de,
      calendar: {
        sameDay: '[Heute]',
        nextDay: '[Morgen]',
        nextWeek: 'ddd DD.MM',
        lastDay: '[Gestern]',
        lastWeek: '[Letzten] dddd',
        sameElse: 'ddd DD.MM'
      }
    })
    moment.updateLocale('en', {
      ...moment_en,
      calendar: {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'ddd DD.MM',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'ddd DD.MM'
      }
    })
  }
}

export default IntlService
